import { compose, withStateHandlers, lifecycle } from "recompose"
import { omitProps } from "recompact"

/**
 * simple api-transport (without Redux)
 *
 * @param {String} propName - name of returned prop
 * @param {Function} load - async function for loading data
 * @return {Function} HOC
 */
const withApiTransport = compose(
  withStateHandlers(({ propName }) => ({ [propName]: undefined }), {
    setApiData: (state, { propName }) => apiData => ({ [propName]: apiData }),
  }),
  lifecycle({
    async componentDidMount() {
      const { setApiData, payload, load } = this.props

      const response = await load(payload)

      setApiData(response)
    },
    componentDidUpdate({ payload: prevPayload }) {
      const { setApiData, payload, load } = this.props

      if (payload === prevPayload) {
        return
      }
      load(payload).then(response => {
        setApiData(response)
      })
    },
  }),
  omitProps([`setApiData`, `payload`, `load`, `propName`]),
)

export default withApiTransport
